<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Prodorder'" :sub-title="prodorder_name" :title-id="prodorder_id">
            <template #header-elements>
                <limitless-page-header-button url="/prodorders" icon="icon-circle-left2">Till Listan</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content" v-if="!initialized && busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="card">
            <div v-if="card.isBlocked" class="alert alert-danger alert-styled-left mb-3">
                <span class="font-weight-semibold">Detta kort är spärrat!</span>
            </div>
            <div v-else-if="!card.card_order" class="alert alert-warning alert-styled-left mb-3">
                <span class="font-weight-semibold">Kortet är ej aktiverat på någon order!</span>
            </div>
            <div v-else-if="!card.isBlocked && card.card_order && (!prodorder || prodorder.ProdOrderID === 0)" class="alert alert-success alert-styled-left mb-3">
                <span class="font-weight-semibold">Kortet är aktivt!</span>
            </div>
            <div v-if="card.isBlocked && prodorder && prodorder.Source === 'direktinlösen'" class="alert alert-info alert-styled-left mb-3">
                <span class="font-weight-semibold">Kom ihåg att ta bort spärren när alla kundens uppgifter är inmatade, annars kommer beställningen inte hanteras av lagret.</span>
            </div>
            <div v-if="duplicates && duplicates.length > 0" class="alert alert-danger alert-styled-left mb-3">
                <div class="font-weight-semibold">OBS! Detta är en dubblettbeställning. Se även:</div>
                <div v-for="dupl in duplicates" :key="'dupl-' + dupl.ProdOrderID">
                    <router-link :to="{ name: 'prodorders.edit', params: { id: dupl.ProdOrderID } }">#{{ dupl.ProdOrderID }}</router-link> inlöst via {{ dupl.Source }} {{ formatDateTime(dupl.OrderTS) }}
                </div>
            </div>
            <div class="card">
                <div class="card-header header-elements-inline bg-light py-2">
                    <h5 class="card-title"><i class="icon-map5 mr-2"></i>Kortinformation</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-auto flex-grow-1">
                            <b style="color: #990000; font-size: 16px;">{{ card.CardUID }}</b>
                            <div>{{ card.CardSeriesID }}: {{ card.card_serie.SeriesName }} ({{ card.card_serie.DeliveryGroup }})</div>
                            <div v-if="card.card_order">
                                Order: <router-link :to="{ name: 'cardorders.edit', params: { id: card.card_order.OrderID }}">
                                    {{ card.card_order.OrderID }}<span v-if="card.card_order.customer"> / {{ card.card_order.customer.CompanyName }} {{ card.card_order.customer.ContactName }}</span>
                                </router-link>
                            </div>
                            <div>Detta kort som testkort: {{ card.CardUID.substring(0, card.CardUID.length - 3) + 'WWW' }}</div>
                            <div v-if="prodorder && prodorder.ProdOrderID > 0" class="mt-3">Beställning: {{ prodorder.ProdOrderID }} / inkom via {{ prodorder.Source }} {{ formatDateTime(prodorder.OrderTS) }}</div>
                        </div>
                        <div v-if="card.smart_info_image" class="col-auto flex-shrink-1">
                            <a :href="card.smart_info_image.url" target="_blank">
                                <img :src="card.smart_info_image.url" height="125">
                            </a>
                        </div>
                        <div v-if="!prodorder || prodorder.ProdOrderID === 0" class="col-auto flex-shrink-1">
                            <div class="row" style="width: 350px;">
                                <label class="col-auto flex-shrink-1 col-form-label">Leveransgrupp:</label>
                                <div class="col-auto flex-grow-1">
                                    <select-with-validation
                                        vid="override_delivery_group"
                                        placeholder="Följer kortserie"
                                        component="delivery-group-filter"
                                        v-model="card.override_delivery_group"
                                        :reduce="(opt) => opt.id"
                                    ></select-with-validation>
                                </div>
                                <div>
                                    <limitless-button
                                        ref="btnsavecard"
                                        :busy="busy_saving_card"
                                        @click="saveCard"
                                    >Spara</limitless-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3">
                        <div class="flex-grow-1">
                            <button v-if="card.isBlocked && card.card_order" type="button" @click="unblockCard" class="btn btn-danger mr-2">TA BORT SPÄRR</button>
                            <button v-else-if="!card.isBlocked && card.card_order" type="button" @click="blockCard" class="btn btn-danger mr-2">SPÄRRA</button>
                            <button v-if="!card.isBlocked && card.card_order && prodorder.ProdOrderID === 0" type="button" @click="saveProdOrder(true)" class="btn btn-info mr-2">DIREKTINLÖSEN</button>
                        </div>
                        <div class="flex-shrink-1">
                            <a v-if="!card.isBlocked && card.card_order" :href="'https://ordergift.se/' + card.CardUID" class="btn btn-danger mr-2" target="_blank">LÖS IN</a>
                            <a v-if="!card.isBlocked && card.card_order" :href="'https://ordergift.se/' + card.CardUID.substring(0, card.CardUID.length - 3) + 'WWW'" class="btn btn-success" target="_blank">TESTINLÖSEN</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="prodorder && prodorder.ProdOrderID > 0">
                    <div class="alert" :class="[ 'alert-' + prodorder.status.Class ]">
                        <div class="row">
                            <div class="col-auto flex-shrink-1">
                                <span class="font-weight-semibold">Status: {{ prodorder.status.StatusID }} - {{ prodorder.status.Status }}</span>
                            </div>
                            <div class="col-auto text-center flex-grow-1" style="margin: -8px 0;">
                                <div v-if="prodorder.StatusID === 55">
                                    <button type="button" class="btn btn-danger" @click="changeStatus(60)">
                                        SÄTT STATUS TILL ÅTGÄRDAD
                                    </button>
                                    <button type="button" class="btn btn-warning" @click="changeStatus(600)">
                                        STÄNG pga saknad återkoppling från kund
                                    </button>
                                </div>
                            </div>
                            <div class="col-auto text-right flex-shrink-1" style="margin: -8px 0;">
                                <div class="btn-group position-static">
                                    <button type="button" class="btn dropdown-toggle mr-2" :class="[ 'btn-outline-' + prodorder.status.Class ]" data-toggle="dropdown" aria-expanded="false">
                                        ÄNDRA STATUS
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a
                                            v-for="status in allowed_status_change"
                                            :key="'a-status-change-' + status.id"
                                            href="#"
                                            class="dropdown-item"
                                            @click.prevent="changeStatus(status.id)"
                                        >
                                            {{ status.name }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="is_paused" class="alert alert-danger">
                    <span class="font-weight-semibold">Denna order är pausad till {{ formatDateTime(prodorder.PausedUntilTS) }}</span>
                </div>
            </div>
            <div v-if="prodorder && prodorder.ProdOrderID > 0" class="row">
                <div class="col-lg-8">
                    <ValidationObserver ref="prodorderform">
                        <form @submit.prevent="saveProdOrder(false)">
                            <div class="card">
                                <div class="card-header header-elements-inline bg-light py-2">
                                    <h5 class="card-title"><i class="icon-user mr-2"></i>Kundinformation</h5>
                                    <div class="header-elements">
                                        <button type="button" class="btn" :class="customer_waiting_class" @click="toggleCustomerWaiting">
                                            <i v-if="prodorder.customerWaiting" class="icon-alert mr-2"></i>Kunden ska ha återkoppling
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <input-with-validation v-model="prodorder.Name" label="Namn" rules="required" vid="Name" compact>
                                                <template #input-group-append>
                                                    <a :href="search_name_link.hitta" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/hitta_se.gif'" alt="hitta.se"></a>
                                                    <a :href="search_name_link.ratsit" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/ratsit_se.png'" alt="ratsit.se"></a>
                                                </template>
                                            </input-with-validation>
                                            <input-with-validation v-model="prodorder.Company" label="Företag" vid="Company" compact>
                                                <template #input-group-append>
                                                    <a :href="search_company_link.hitta" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/hitta_se.gif'" alt="hitta.se"></a>
                                                    <a :href="search_company_link.ratsit" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/ratsit_se.png'" alt="ratsit.se"></a>
                                                </template>
                                            </input-with-validation>
                                            <input-with-validation v-model="prodorder.Street" label="Gatuadress" :rules="{ required: prodorder.DeliveryType !== 'online' }" vid="Street" compact>
                                                <template #input-group-append>
                                                    <a :href="search_adress_link.hitta" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/hitta_se.gif'" alt="hitta.se"></a>
                                                    <a :href="search_adress_link.ratsit" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/ratsit_se.png'" alt="ratsit.se"></a>
                                                </template>
                                            </input-with-validation>
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <input-with-validation v-model="prodorder.Zip" label="Postnummer" :rules="{ required: prodorder.DeliveryType !== 'online' }" vid="Zip" compact />
                                                </div>
                                                <div class="col-lg-8">
                                                    <input-with-validation v-model="prodorder.City" label="Postort" :rules="{ required: prodorder.DeliveryType !== 'online' }" vid="City" compact />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <select-with-validation
                                                        component="country-filter"
                                                        v-model="prodorder.CountryCode"
                                                        :reduce="(opt) => opt.id"
                                                        label="Land"
                                                        rules="required"
                                                        vid="CountryCode"
                                                        compact
                                                        :clearable="false"
                                                    />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-8">
                                                    <select-with-validation
                                                        component="door-type-filter"
                                                        v-model="prodorder.DoorType"
                                                        :reduce="(opt) => opt.id"
                                                        label="Dörrtyp"
                                                        vid="DoorType"
                                                        compact
                                                        clearable
                                                    />
                                                </div>
                                                <div class="col-lg-4">
                                                    <input-with-validation
                                                        v-model="prodorder.DoorAccessCode"
                                                        label="Portkod"
                                                        vid="DoorAccessCode"
                                                        compact
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <input-with-validation v-model="prodorder.Phone" label="Telefon" :rules="{ required: !(prodorder.Email) }" vid="Phone" compact>
                                                <template #input-group-append>
                                                    <a :href="search_phone_link.hitta" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/hitta_se.gif'" alt="hitta.se"></a>
                                                    <a :href="search_phone_link.ratsit" target="sht_hitta_popup" class="btn btn-light px-2"><img :src="old_system_url + '/img/ratsit_se.png'" alt="ratsit.se"></a>
                                                </template>
                                            </input-with-validation>
                                            <input-with-validation v-model="prodorder.Email" label="E-postadress" :rules="{ required: !(prodorder.Phone) }" vid="Email" compact />
                                            <div class="custom-control custom-checkbox custom-control-inline mb-3">
                                                <input type="checkbox" class="custom-control-input" id="chk-want-info" v-model="prodorder.WantInfoMail" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-want-info">Vill ha info/nyhetsbrev</label>
                                            </div>
                                            <textarea-with-validation v-model="prodorder.TransportInstruction" label="Transportinstruktion" vid="TransportInstruction" compact />
                                            <div style="margin-top: 15px;">
                                                <div>Kolla: <img :src="old_system_url + '/img/posten_se.gif'" alt="posten"></div>
                                                <div class="ml-2">
                                                    <a href="#" @click.prevent="winOpen('/postnord/postnummer/' + street_wo_apartmentno + ',' + prodorder.City)" target="SHT_InfoPop">- Postnummer</a><br>
                                                    <a href="#" @click.prevent="winOpen('/postnord/deliverytime/' + prodorder.CountryCode + '/' + prodorder.Zip.replaceAll(' ', ''))" target="SHT_InfoPop">- Leveranstid</a><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-header header-elements-inline bg-light border-top">
                                    <h5 class="card-title"><i class="icon-truck mr-2"></i>Leverans</h5>
                                    <div class="header-elements">
                                        <div v-if="prodorder.IsDeliverable" class="badge badge-success">Flaggad som levererbar</div>
                                        <div v-else class="badge badge-danger">Ej flaggad som levererbar</div>
                                    </div>
                                </div>
                                <div class="card-body pb-0">
                                    <div v-if="prodorder.StatusID !== 510 && prodorder.DeliveryType !== 'online'" class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label>Önskat lev. datum</label>
                                                <div class="d-flex">
                                                    <ValidationProvider tag="div" class="flex-grow-1" vid="DeliveryDate" name="Leveransdatum" rules="required" v-slot="{ errors }">
                                                        <v-date-picker v-model="prodorder.WantedDeliveryDate" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                            <template v-slot="{ inputValue, togglePopover }">
                                                                <div class="input-group">
                                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'bg-danger-200': !prodorder.WantedDeliveryDate || prodorder.WantedDeliveryDate === '0000-00-00' }">
                                                                    <span class="input-group-append">
                                                                        <button class="btn btn-light" type="button" @click="prodorder.WantedDeliveryDate = ''"><i class="icon-cross3"></i></button>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </v-date-picker>
                                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <div class="pl-2 d-flex flex-column justify-content-center align-middle" style="width: 55px;">
                                                        <div class="badge bg-teal text-uppercase text-white" v-if="deliv_date_str" v-html="deliv_date_str"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Skickas</label>
                                                <div v-if="prodorder.DeliveryASAP" class="d-block badge badge-teal">SKICKAS SNARAST</div>
                                                <div v-else class="d-flex">
                                                    <ValidationProvider tag="div" class="flex-grow-1" vid="CalcShippingDate" name="Skickas" v-slot="{ errors }">
                                                        <v-date-picker v-model="prodorder.CalcShippingDate" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                            <template v-slot="{ inputValue, togglePopover }">
                                                                <div class="input-group">
                                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'bg-danger-200': !prodorder.CalcShippingDate || prodorder.CalcShippingDate === '0000-00-00' }">
                                                                    <span class="input-group-append">
                                                                        <button class="btn btn-light" type="button" @click="prodorder.CalcShippingDate = ''"><i class="icon-cross3"></i></button>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </v-date-picker>
                                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                    <div class="pl-2 d-flex flex-column justify-content-center align-middle" style="width: 55px;">
                                                        <div class="badge bg-teal text-uppercase text-white" v-if="date_send_str" v-html="date_send_str"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label>Beräknad leveranstid</label>
                                                <div
                                                    v-if="deliv_calc_deliv_date && deliv_calc_send_date && deliv_calc_deliv_day && deliv_calc_send_day"
                                                    class="font-weight-semibold"
                                                >
                                                    <span class="text-uppercase">{{ deliv_calc_send_day }}</span>
                                                    <a href="#" @click.prevent="prodorder.CalcShippingDate = deliv_calc_send_date" title="Sätt Skickas"> {{ deliv_calc_send_date }}</a>
                                                    <span class="text-uppercase"> -> {{ deliv_calc_deliv_day }}</span>
                                                    <a href="#" @click.prevent="prodorder.WantedDeliveryDate = deliv_calc_deliv_date" title="Sätt Önskat leveransdatum"> {{ deliv_calc_deliv_date }}</a>
                                                    <div v-if="deliv_calc_text" v-html="deliv_calc_text"></div>
                                                </div>
                                                <div v-else-if="deliv_calc_text" class="alert alert-danger font-weight-bold" v-html="deliv_calc_text"></div>
                                            </div>
                                            <div v-if="prodorder.DeliveryType !== 'online'" class="form-group">
                                                <label>Leveransgrupp</label>
                                                <select-with-validation
                                                    vid="override_delivery_group"
                                                    placeholder="Följer kortserie"
                                                    component="delivery-group-filter"
                                                    v-model="card.override_delivery_group"
                                                    :reduce="(opt) => opt.id"
                                                ></select-with-validation>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="prodorder.StatusID !== 510">
                                        <div class="col-lg-6">
                                            <select-with-validation
                                                vid="DeliveryType"
                                                label="Fraktsätt"
                                                v-model="prodorder.DeliveryType"
                                                :reduce="(opt) => opt.id"
                                                component="delivery-type-filter"
                                                rules="required"
                                                :clearable="false"
                                            ></select-with-validation>
                                        </div>
                                        <div
                                            v-if="prodorder.DeliveryType === 'postoffice'"
                                            class="col-lg-6"
                                        >
                                            <select-with-validation
                                                vid="service_point"
                                                label="Ombud"
                                                v-model="prodorder.service_point"
                                                :service-point="service_point"
                                                :criteria="service_point_criteria"
                                                component="service-point-filter"
                                                placeholder="Postnord väljer ombud"
                                            ></select-with-validation>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="table-responsive mb-0 border-bottom">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 100px;" class="px-1 py-2 text-center">SKU</th>
                                                        <th style="width: 38px;" class="px-1 py-2">
                                                            <div style="width: 38px; height: 2px; background-color: #fff;"></div>
                                                        </th>
                                                        <th class="px-1 py-2">Benämning</th>
                                                        <th style="width: 20px;" class="px-1 py-2"></th>
                                                        <th style="width: 111px;" class="px-1 py-2"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, itm_idx) in prodorder.items" :key="'item-' + itm_idx">
                                                        <td class="p-1">
                                                            <ValidationProvider :vid="'items.' + itm_idx + '.CardSeriesID'" name="SKU" rules="" v-slot="{ errors }">
                                                                <input type="text" class="form-control" v-model="item.ProdID" :class="{'border-danger':errors[0]}" readonly>
                                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                            </ValidationProvider>
                                                        </td>
                                                        <td class="p-1">
                                                            <div v-if="item.product.images && item.product.images.length > 0">
                                                                <div :id="`product-image-${item.ProdID}-${itm_idx}`"
                                                                     style="width: 38px; height: 38px; background-repeat: no-repeat; background-position: center; background-size: cover;"
                                                                     :style="{ 'background-image': 'url(' + item.product.images[0].urls['small'] + ') '}"
                                                                ></div>
                                                                <b-popover :target="`product-image-${item.ProdID}-${itm_idx}`" triggers="hover">
                                                                    <img :src="item.product.images[0].urls['medium']" :alt="item.ProdID" style="width: 100%;">
                                                                </b-popover>
                                                            </div>
                                                            <div v-else style="width: 38px; height: 38px; background-color: #ccc;"></div>
                                                        </td>
                                                        <td class="p-1 position-relative">
                                                            <ValidationProvider :vid="'items.' + itm_idx + '.ProdName'" name="Benämning" rules="" v-slot="{ errors }">
                                                                <input type="text" class="form-control" v-model="item.ProdName" :class="{'border-danger':errors[0]}" readonly>
                                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                            </ValidationProvider>
                                                            <div style="position: absolute; right: 12px; top: 13px;">
                                                                <div v-if="item.IsCompensation"
                                                                     class="badge badge-warning"
                                                                >KOMPENSATION</div>
                                                                <div v-if="!(item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00') && !item.IsReserved && item.product.isPhasedOut === 1"
                                                                     class="badge badge-danger"
                                                                >HAR UTGÅTT</div>
                                                                <div v-else-if="!(item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00') && !item.IsReserved && item.product.isOutOfStock"
                                                                     class="badge badge-danger"
                                                                >TILLF. SLUT</div>
                                                            </div>
                                                        </td>
                                                        <td class="p-1">
                                                            <div class="d-flex">
                                                                <i :id="`product-stock-${item.ProdID}-${itm_idx}`" class="icon icon-info22 mr-2"></i>
                                                                <i
                                                                    :id="`product-reserved-${item.ProdID}-${itm_idx}`"
                                                                    class="icon"
                                                                    :class="[
                                                                        (
                                                                            (item.product.sendByExternalSupplier ? !!(item.ExportedTS) : (item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00'))
                                                                            ? 'icon-check text-success'
                                                                            : ((item.product.sendByExternalSupplier || item.IsReserved) ? 'icon-check text-primary' : 'icon-cross text-danger')
                                                                        )
                                                                    ]"
                                                                ></i>
                                                            </div>
                                                            <b-popover :target="`product-stock-${item.ProdID}-${itm_idx}`" triggers="hover click" custom-class="wide-popover">
                                                                <div v-if="item.product.isStruct" class="badge badge-info mb-1">STRUKTURARTIKEL</div>
                                                                <div v-if="item.product.isPhasedOut === 1" class="badge badge-danger mb-1">HAR UTGÅTT</div>
                                                                <div v-else-if="item.product.isOutOfStock" class="badge badge-danger mb-1">TILLF. SLUT</div>
                                                                <div v-if="item.product.sendByExternalSupplier || item.sub_products && Array.isArray(item.sub_products) && item.sub_products.length > 0">
                                                                    <div v-if="item.product.sendByExternalSupplier">
                                                                        <span class="font-weight-semibold">Skickad till extern leverantör:</span>
                                                                        <span v-if="item.ExportedTS" class="ml-1 badge badge-success">{{ formatDateTime(item.ExportedTS) }}</span>
                                                                        <span v-else class="ml-1 badge badge-danger">Nej</span>
                                                                    </div>
                                                                    <div v-if="item.sub_products && Array.isArray(item.sub_products) && item.sub_products.length > 0" class="mt-2">
                                                                        <div
                                                                            v-for="(sub_prod, sub_idx) in item.sub_products"
                                                                            :key="'item-' + itm_idx + '-sub-' + sub_idx"
                                                                            style="white-space: nowrap; margin-bottom: 10px;"
                                                                        >
                                                                            <div class="d-flex flex-row flex-nowrap">
                                                                                <div v-if="sub_prod.image_url" class="pr-2">
                                                                                    <img :src="sub_prod.image_url" :alt="sub_prod.prod_name" style="width: 65px;">
                                                                                </div>
                                                                                <div class="flex-grow-1">
                                                                                    <div class="font-weight-semibold">Titel: {{ sub_prod.prod_name }}</div>
                                                                                    <div v-if="sub_prod.type === 'pocket_pack'">ISBN: {{ sub_prod.isbn }}</div>
                                                                                    <div v-if="sub_prod.type === 'magazine_subscription'">Antal nummer: {{ sub_prod.no_of_issues }}</div>
                                                                                    <div v-if="sub_prod.type === 'magazine_subscription'">Förlag: {{ sub_prod.source }}</div>
                                                                                    <div v-if="sub_prod.supplier_art_no">Lev. art.no: {{ sub_prod.supplier_art_no }}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    <div>Lagersaldo: <span :class="{ 'text-success': item.product.Stock_today > 0, 'text-danger': item.product.Stock_today <= 0 }">{{ item.product.Stock_today }}</span></div>
                                                                    <div>Disponibelt saldo: <span :class="{ 'text-success': item.product.Stock_future > 0, 'text-danger': item.product.Stock_future <= 0 }">{{ item.product.Stock_future }}</span></div>
                                                                    <div v-if="item.product.purchase_items && Array.isArray(item.product.purchase_items) && item.product.purchase_items.length > 0">
                                                                        <hr>
                                                                        Kommande inköp:
                                                                        <div
                                                                            v-for="(purchaseItem, pi_index) in item.product.purchase_items"
                                                                            :key="'pi-' + pi_index"
                                                                        >
                                                                            {{ purchaseItem.EffectiveTS ? purchaseItem.EffectiveTS.substring(0, 10) : 'Antal' }}: {{ purchaseItem.Antal }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-popover>
                                                            <b-popover :target="`product-reserved-${item.ProdID}-${itm_idx}`" triggers="hover" custom-class="wide-popover">
                                                                <div v-if="item.product.sendByExternalSupplier">
                                                                    <span class="font-weight-semibold">Skickad till extern leverantör:</span>
                                                                    <span v-if="item.ExportedTS" class="ml-1 badge badge-success">{{ formatDateTime(item.ExportedTS) }}</span>
                                                                    <span v-else class="ml-1 badge badge-danger">Nej</span>
                                                                </div>
                                                                <div v-else>
                                                                    <div v-if="item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00'">Levererad: {{ formatDateTime(item.DeliveredTS) }}</div>
                                                                    <div v-else-if="item.IsReserved">Reserverad</div>
                                                                    <div v-else>{{ 'Ej reserverad' + (item.product.ProductCodeTypeID > 0 ? '' : ': kan ej levereras') }}</div>
                                                                </div>
                                                            </b-popover>
                                                        </td>
                                                        <td class="p-1">
                                                            <div class="d-flex">
                                                                <button v-if="item.product.ProductCodeTypeID > 0" type="button" class="btn btn-light mr-1" @click="showCodes(item)"><i class="icon-ticket"></i></button>
                                                                <router-link :to="{ name: 'products.edit', params: { id: item.ProdID} }" target="_blank" class="btn btn-light mr-1"><i class="icon-gift"></i></router-link>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-danger"
                                                                    @click="deleteOrderItem(itm_idx, item.RowLock)"
                                                                    :disabled="!!((prodorder.StatusID >= 200 && prodorder.StatusID !== 250) || (item.DeliveredTS && item.DeliveredTS !== '0000-00-00 00:00:00') || item.ExportedTS)"
                                                                >
                                                                    <i class="icon-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-if="(prodorder.StatusID < 200 || prodorder.StatusID === 250) && (card.card_serie.is_points || (prodorder.items.length < (card.card_serie.NoOfChoices + 1)))" class="p-1">
                                            <product-filter
                                                :placeholder="'Lägg till ' + ((!card.card_serie.is_points && prodorder.items.length >= card.card_serie.NoOfChoices) ? 'kompensation': 'produkt') + '...'"
                                                @option:selected="addOrderItem($event, (!card.card_serie.is_points && prodorder.items.length >= card.card_serie.NoOfChoices))"
                                                v-model="add_product"
                                                show-status
                                            ></product-filter>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="d-flex justify-content-between">
                                        <limitless-button
                                            v-show="prodorder && prodorder.ProdOrderID > 0"
                                            ref="btnPrintLabel"
                                            btn-class="btn-warning"
                                            type="button"
                                            @click="btnPrintLabel"
                                            icon="icon-printer"
                                        >
                                            Skriv ut FRAKTSEDEL
                                        </limitless-button>
                                        <limitless-button
                                            v-show="prodorder && prodorder.ProdOrderID > 0"
                                            ref="btnPrintLetter"
                                            btn-class="btn-warning ml-3"
                                            type="button"
                                            @click="btnPrintLetter"
                                            icon="icon-printer"
                                        >
                                            Skriv ut BREVETIKETT
                                        </limitless-button>
<!--                                        <limitless-button-->
<!--                                            v-show="prodorder && prodorder.ProdOrderID > 0"-->
<!--                                            ref="btnPrintPtouch"-->
<!--                                            btn-class="btn-warning ml-3"-->
<!--                                            type="button"-->
<!--                                            @click="btnPrintPtoch"-->
<!--                                            icon="icon-printer"-->
<!--                                        >-->
<!--                                            Skriv ut P-TOUCH-->
<!--                                        </limitless-button>-->
                                        <limitless-button
                                            ref="btnsaveprodorder"
                                            type="button"
                                            @click="saveProdOrder(false)"
                                            :busy="busy_saving"
                                            icon="icon-floppy-disk"
                                            class="ml-auto"
                                        >
                                            Spara
                                        </limitless-button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                    <div class="btn-group position-static">
                        <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left dropdown-toggle mr-2" data-toggle="dropdown" aria-expanded="false">
                            <b><i class="icon-mention"></i></b> SKICKA MAIL
                        </button>
                        <div class="dropdown-menu dropdown-menu-left">
                            <button type="button" class="dropdown-item" @click="showModalMail('confirmation')">BEKRÄFTELSE</button>
                            <button type="button" class="dropdown-item" @click="showModalMail('delayed_delivery')" :disabled="has_packages_en_route || has_packages_to_collect">FÖRSENAD LEVERANS</button>
                            <button type="button" class="dropdown-item" @click="showModalMail('phased_out')" :disabled="has_packages_en_route || has_packages_to_collect">PRODUKT UTGÅTT</button>
                            <button type="button" class="dropdown-item" @click="showModalMail('delivery_notice')" :disabled="!has_packages_en_route">LEVERANSBESKED</button>
                            <button type="button" class="dropdown-item" @click="showModalMail('ready_for_pickup')" :disabled="!has_packages_to_collect">FINNS ATT HÄMTA</button>
                        </div>
                    </div>
                    <div class="btn-group position-static">
                        <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left dropdown-toggle mr-2" data-toggle="dropdown" aria-expanded="false">
                            <b><i class="icon-mobile"></i></b> SKICKA SMS
                        </button>
                        <div class="dropdown-menu dropdown-menu-left">
<!--                            <button type="button" class="dropdown-item" @click="showModalMail('confirmation')">BEKRÄFTELSE</button>-->
                            <button type="button" class="dropdown-item" @click="showModalSms('delayed_delivery')" :disabled="has_packages_en_route || has_packages_to_collect">FÖRSENAD LEVERANS</button>
                            <button type="button" class="dropdown-item" @click="showModalSms('phased_out')" :disabled="has_packages_en_route || has_packages_to_collect">PRODUKT UTGÅTT</button>
                            <button type="button" class="dropdown-item" @click="showModalSms('delivery_notice')" :disabled="!has_packages_en_route">LEVERANSBESKED</button>
                            <button type="button" class="dropdown-item" @click="showModalSms('ready_for_pickup')" :disabled="!has_packages_to_collect">FINNS ATT HÄMTA</button>
                            <button type="button" class="dropdown-item" @click="showModalSms('message')">MEDDELANDE</button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card" v-if="prodorder && prodorder.ProdOrderID > 0">
                        <div class="card-header header-elements-inline bg-light">
                            <a data-toggle="collapse" class="text-body" href="#collapse-parcels">
                                <h5 class="card-title"><i class="icon-truck mr-2"></i>Utskrivna fraktsedlar</h5>
                            </a>
                        </div>
                        <div id="collapse-parcels" class="collapse">
                            <div v-if="busy_loading_parcels" class="card-body">
                                <i class="icon-spinner2 spinner"></i>
                            </div>
                            <div v-else-if="parcels && ((parcels.unifaun && parcels.unifaun.length > 0) || (parcels.ntaps && parcels.ntaps.length > 0))">
                                <table class="table table-xs">
                                    <tbody>
                                    <template v-if="parcels.unifaun && parcels.unifaun.length > 0">
                                        <tr v-for="(up, up_index ) in parcels.unifaun" :key="'up-' + up_index">
                                            <td :class="{ 'text-line-through': up.isHidden }"><nobr>{{ formatDateTime(up.printdate).substring(0, 16) }}</nobr></td>
                                            <td :class="{ 'text-line-through': up.isHidden }">
                                                <div>{{ up.kollino }}</div>
                                                <div>
                                                    <a :href="'https://www.postnord.se/vara-verktyg/spara-brev-paket-och-pall?shipmentId=' + up.kollino" :id="'link-' + up.kollino">[PT] {{ up.status ? up.status.StatusDesc : 'Status saknas' }}</a>
                                                    <b-popover key="warning-out-of-stock" :target="'link-' + up.kollino" triggers="hover focus" placement="bottom" v-if="up.pt_datedelivered || up.pt_acceptor">
                                                        <div v-if="up.pt_datedelivered">Levererat: {{ formatDateTime(up.pt_datedelivered) }}</div>
                                                        <div v-if="up.pt_acceptor">Mottaget av: {{ up.pt_acceptor }}</div>
                                                    </b-popover>
                                                </div>
                                            </td>
                                            <td>
                                                <a v-if="!up.isHidden" class="badge badge-warning" :href="old_system_url + '/showPDF_PostReklamation.php?CardNo=' + prodorder.CardNo + '&KolliNo=' + up.kollino">REKL.</a>
                                                <a v-if="!up.isHidden" class="badge badge-warning cursor-pointer" @click.prevent="tearShippingLabel(up.kollino)">RIV</a>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="parcels.ntaps && parcels.ntaps.length > 0">
                                        <tr v-for="(np, np_index ) in parcels.ntaps" :key="'np-' + np_index">
                                            <td :class="{ 'text-line-through': !!(np.shipment.deleted_at) }">
                                                <nobr>{{ formatDateTime(np.shipment.created_at).substring(0, 16) }}</nobr>
                                                <div class="text-muted">{{ np.shipment.service_type }}</div>
                                            </td>
                                            <td :class="{ 'text-line-through': !!(np.shipment.deleted_at) }">
                                                <div>{{ np.parcel_number }}<span v-if="np.shipment.service_type.includes('RETURN')"><i class="icon-rotate-ccw3 text-danger"></i></span></div>
                                                <div>
                                                    <a v-if="np.shipment.service_type.indexOf('UPS-') === 0" :href="'https://www.ups.com/track?loc=en_SE&tracknum=' + np.parcel_number + '&requester=ST/trackdetails'" :id="'link-' + np.parcel_number" target="_blank">[PT] {{ np.status ? np.status.StatusDesc : 'Status saknas' }}</a>
                                                    <a v-else :href="'https://www.postnord.se/vara-verktyg/spara-brev-paket-och-pall?shipmentId=' + np.parcel_number" :id="'link-' + np.parcel_number" target="_blank">[PT] {{ np.status ? np.status.StatusDesc : 'Status saknas' }}</a>
                                                    <b-popover key="warning-out-of-stock" :target="'link-' + np.parcel_number" triggers="hover focus" placement="bottom" v-if="np.delivered_at || np.acceptor">
                                                        <div v-if="np.delivered_at">Levererat: {{ formatDateTime(np.delivered_at) }}</div>
                                                        <div v-if="np.acceptor">Mottaget av: {{ np.acceptor }}</div>
                                                    </b-popover>
                                                </div>
                                            </td>
                                            <td>
                                                <a v-if="np.meta && np.meta.label_printout" type="button" class="badge badge-info" @click.prevent="showShippingLabel(np)">Label</a>
                                                <router-link v-if="!np.shipment.deleted_at" class="badge badge-warning" :to="{ name: 'shipping.complaints.create', params: { parcelId: np.id } }">REKL.</router-link>
                                                <a v-if="!np.shipment.deleted_at" class="badge badge-warning cursor-pointer" @click.prevent="tearShippingLabel(np.parcel_number)">RIV</a>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="card-body">
                                <i>Inga fraktsedlar</i>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header header-elements-inline bg-light py-2">
                            <h5 class="card-title"><i class="icon-list mr-2"></i>Logg</h5>
<!--                            <div class="header-elements">-->
<!--                                <button type="button" class="btn btn-light" @click="show_full_log = !show_full_log">{{ (show_full_log ? 'Dölj' : 'Visa') }} automatiska loggar</button>-->
<!--                            </div>-->
                        </div>
                        <div class="overflow-auto d-flex flex-column-reverse" style="max-height: 500px;">
                            <div
                                v-for="(log, l_index) in filteredLogs"
                                :key="'l-' + l_index"
                                class="border-bottom p-2"
                            >
                                <div>
                                    <span class="font-weight-semibold">{{ (log.user ? log.user.FullName : log.CommentBy) }}</span>
                                    <span class="text-muted">
                                        <span class="mx-1">&bull;</span>
                                        {{ formatDateTime(log.CommentTS) }}
                                    </span>
                                    <span v-if="log.CommentType" class="text-muted">
                                        <span class="mx-1">&bull;</span>
                                        {{ log.CommentType }}
                                    </span>
                                    <template v-if="log.data">
                                        <span v-if="log.data.delivery_channel === 'sms'" class="badge badge-light ml-1" :title="'SMS-id: ' + (log.data.sent_id || 'saknas')">SMS</span>
                                        <span v-if="log.data.delivered_ts || log.data.opened_ts || log.data.clicked_ts || log.data.bounced_ts" class="mx-1 text-muted">&bull;</span>
                                        <span v-if="log.data.delivered_ts">
                                            <i :id="'delivered_ts-' + log.ProdOrderCommentID" :class="log.data.delivery_channel === 'sms' ? 'icon-mobile text-success' : 'icon-mail5 text-success'"></i>
                                            <b-popover key="warning-delivered_ts" :target="'delivered_ts-' + log.ProdOrderCommentID" triggers="hover focus" placement="bottom">
                                                Levererat: {{ formatDateTime(log.data.delivered_ts) }}
                                            </b-popover>
                                        </span>
                                        <span v-if="log.data.delivery_channel !== 'sms' && log.data.opened_ts">
                                            <i :id="'opened_ts-' + log.ProdOrderCommentID" class="icon-mail-read text-success"></i>
                                            <b-popover key="warning-opened_ts" :target="'opened_ts-' + log.ProdOrderCommentID" triggers="hover focus" placement="bottom">
                                                Öppnat: {{ formatDateTime(log.data.opened_ts) }}
                                            </b-popover>
                                        </span>
                                        <span v-if="log.data.delivery_channel !== 'sms' && log.data.clicked_ts">
                                            <i :id="'clicked_ts-' + log.ProdOrderCommentID" class="icon-touch text-success"></i>
                                            <b-popover key="warning-clicked_ts" :target="'clicked_ts-' + log.ProdOrderCommentID" triggers="hover focus" placement="bottom">
                                                Klickat: {{ formatDateTime(log.data.clicked_ts) }}
                                            </b-popover>
                                        </span>
                                        <span v-if="log.data.bounced_ts">
                                            <i :id="'bounced_ts-' + log.ProdOrderCommentID" class="icon-cross2 text-danger"></i>
                                            <b-popover key="warning-bounced_ts" :target="'bounced_ts-' + log.ProdOrderCommentID" triggers="hover focus" placement="bottom">
                                                <div>Ej levererat: {{ formatDateTime(log.data.bounced_ts) }}</div>
                                                <div>{{ log.data.bounced_msg }}</div>
                                            </b-popover>
                                        </span>
                                    </template>
                                </div>
                                <div v-html="nl2br(log.CommentText)"></div>
                            </div>
                        </div>
                        <div class="card-body">
                            <ValidationObserver ref="logform">
                                <form @submit.prevent="saveComment">
                                    <select-with-validation
                                        vid="CommentType"
                                        rules="required"
                                        label="Kommentarstyp"
                                        v-model="comment.CommentType"
                                        :reduce="(opt) => opt.id"
                                        :options="comment_types"
                                        hide-label
                                        class="mb-0"
                                        :clearable="false"
                                    ></select-with-validation>
                                    <textarea-with-validation
                                        vid="CommentText"
                                        rules="required"
                                        label="Kommentarer"
                                        v-model="comment.CommentText"
                                        :disabled="busy_saving_log"
                                        placeholder="Skriv i loggen..."
                                        hide-label
                                    ></textarea-with-validation>
                                    <div class="text-right mt-2">
                                        <limitless-button ref="btnsavecomment" @click="saveComment" icon="icon-pencil3" :busy="busy_saving_log">SKRIV</limitless-button>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                    <div v-if="prodorder && prodorder.ProdOrderID > 0" class="card">
                        <div class="card-header header-elements-inline bg-light">
                            <a data-toggle="collapse" class="text-body" href="#collapse-freight-costs">
                                <h5 class="card-title"><i class="icon-coins mr-2"></i>Fraktkostnader</h5>
                            </a>
                        </div>
                        <div id="collapse-freight-costs" class="collapse">
                            <div v-if="busy_loading_parcels" class="card-body">
                                <i class="icon-spinner2 spinner"></i>
                            </div>
                            <div v-else-if="freight_costs && freight_costs.length > 0">
                                <table class="table table-xs">
                                    <tbody>
                                        <tr v-for="(fc, fc_index ) in freight_costs" :key="'fc-' + fc_index">
                                            <td>{{ formatDateTime(fc.price_date).substring(0, 10) }}</td>
                                            <td>{{ fc.parcel_number }}</td>
                                            <td class="text-right">{{ formatCurrency(fc.price) }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="2" class="text-right">Totalt:</th>
                                            <th class="text-right font-weight-semibold">{{ formatCurrency(freight_costs.reduce((val, parcel) => val + parcel.price, 0)) }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div v-else class="card-body">
                                <i>Inga fraktkostnader registrerade</i>
                            </div>
                        </div>
                    </div>
                    <div v-if="prodorder && prodorder.ProdOrderID > 0" class="card">
                        <div class="card-header header-elements-inline bg-light py-2">
                            <a data-toggle="collapse" class="text-body" href="#collapse-product-complaints">
                                <h5 class="card-title"><i class="icon-rotate-ccw3 mr-2"></i>Reklamationer</h5>
                            </a>
                            <div class="header-elements">
                                <router-link :to="{ name: 'returnorder.edit', params: { id: 0 }, query: { prod_order_id: prodorder.ProdOrderID } }" class="btn btn-light">Skapa ny reklamation</router-link>
                            </div>
                        </div>
                        <div id="collapse-product-complaints" class="collapse">
                            <div v-if="busy_loading_returnorders" class="card-body">
                                <i class="icon-spinner2 spinner"></i>
                            </div>
                            <div v-else-if="returnorders && returnorders.length > 0">
                                <table class="table table-xs">
                                    <tbody>
                                        <template v-for="(ro, ro_index ) in returnorders">
                                            <tr :key="'ro-row-' + ro_index">
                                                <td><router-link :to="{ name: 'returnorder.edit', params: { id: ro.ReturnOrderID } }">{{ ro.ReturnOrderID }}</router-link></td>
                                                <td><router-link :to="{ name: 'returnorder.edit', params: { id: ro.ReturnOrderID } }">{{ formatDateTime(ro.CreatedTS) }}</router-link></td>
                                                <td><router-link :to="{ name: 'returnorder.edit', params: { id: ro.ReturnOrderID } }">{{ ro.ResendReason }} / {{ ro.ResendReasonBy }}</router-link></td>
                                                <td><div class="badge" :class="['badge-' + ro.StatusClass]">{{ ro.StatusName }}</div></td>
                                            </tr>
                                            <tr :key="'ro-desc-' + ro_index" v-if="ro.internal_comment || ro.comments.length > 0">
                                                <td style="border-top: 0;"></td>
                                                <td
                                                    colspan="3"
                                                    style="border-top: 0;"
                                                    v-html="nl2br((ro.internal_comment ? ro.internal_comment + ' ' : '') + ro.comments.map((c) => c.CommentText).join(' '))"
                                                ></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="card-body">
                                <i>Inga produktreklamationer registrerade</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal title="Produktkoder" id="modal-show-codes" ok-title="Stäng" ok-variant="light" ok-only>
                <div v-if="codes_item">
                    <div v-for="code in codes_item.codes" :key="'code-' + code.code">
                        {{ code.code }}<span v-if="code.expire_date"> - Giltig till {{ code.expire_date }}</span>
                    </div>
                </div>
            </b-modal>

            <b-modal
                id="modal_sms_form"
                title="Skicka SMS"
                key="modal_sms_form"
                ok-title="Skicka"
                cancel-title="Stäng"
                cancel-variant="light"
                size="sm"
                @ok="sendSms"
                :ok-disabled="!show_send_button_sms"
            >
                <div v-if="prodorder">
                    <ValidationObserver ref="smsform">
                        <form @submit.prevent="sendSms">
                            <input-with-validation
                                vid="from"
                                rules="required"
                                label="Från"
                                v-model="sms.from"
                                disabled
                                placeholder="Från"
                            ></input-with-validation>
                            <input-with-validation
                                vid="to"
                                rules="required"
                                label="Till"
                                v-model="sms.to"
                                disabled
                                placeholder="Mobiltelefonnummer"
                            ></input-with-validation>
                            <textarea-with-validation
                                vid="message"
                                rules="required"
                                label="Meddelande"
                                v-model="sms.message"
                                :disabled="busy_sending_sms"
                                placeholder="Skriv ett meddelande..."
                                :rows="4"
                            ></textarea-with-validation>
                        </form>
                    </ValidationObserver>
                    <div style="font-size: 12px;" class="text-muted">
                        <div>Antal SMS: {{ sms_count.messages }}</div>
                        <div>Encoding: {{ sms_count.encoding }}</div>
                        <div>Antal tecken kvar: {{ sms_count.remaining }}</div>
                    </div>
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel">Stäng</button>
                    <limitless-button ref="btnsendsms" icon="icon-paperplane" @click="ok" :disabled="!sms.to">Skicka</limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_mail_preview"
                :title="'Skicka ' + mail_type_human"
                key="modal_mail_preview"
                ok-title="Skicka"
                cancel-title="Stäng"
                cancel-variant="light"
                size="xl"
                @ok="sendMail"
                :ok-disabled="!show_send_button_email"
            >
                <div v-if="prodorder">
                    <ValidationObserver ref="mailform">
                        <div
                            v-if="(mail_type === 'delivery_notice' || mail_type === 'ready_for_pickup')
                             && (this.parcels.unifaun.filter((row) => !row.isHidden && row.kollino).length <= 0 && this.parcels.ntaps.filter((row) => !row.deleted_at).length <= 0)"
                            class="alert alert-warning"
                        >
                            Det finns inga kollinummer kopplade till denna order, vill du verkligen skicka leveransbesked?
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" style="max-width: 150px;">Till:</label>
                            <div class="col" style="max-width: 500px;">
                                <input type="text" :value="prodorder.Email" class="form-control" readonly>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col col-form-label" style="max-width: 150px;">Meddelande:</label>
                            <div class="col" style="max-width: 500px;">
                                <ValidationProvider vid="message" name="Meddelande" v-slot="{ errors }">
                                    <elastic-textarea type="text" v-model="mail.message" class="form-control" :class="{'border-danger':errors[0]}" :strip-tags="false"></elastic-textarea>
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                    </ValidationObserver>
                    <hr>
                    <iframe
                        v-if="mail_preview_url"
                        :src="mail_preview_url"
                        style="border: 0; width: 100%;"
                        :style="{ height: (mail_type=== 'message' ? 1000 : (mail.message ? 2000 : 1700)) + 'px' }"
                    ></iframe>
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel">Stäng</button>
                    <limitless-button ref="btnsendmail" icon="icon-paperplane" @click="ok" :disabled="!prodorder.Email">Skicka</limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_show_shipping_label"
                title="Fraktsedel"
                key="modal_show_shipping_label"
                ok-only
                scrollable
                ok-title="Stäng"
                ok-variant="light"
                size="xl"
                @hide="this.show_shipping_label = null;"
            >
                <div v-if="show_shipping_label && show_shipping_label.meta && show_shipping_label.meta.label_printout && show_shipping_label.meta.label_printout.length > 0">
                    <div
                        v-for="(label, l_index) in show_shipping_label.meta.label_printout"
                        :key="'label-' + l_index"
                    >
                        <div v-if="label.type === 'LABEL'">
                            <iframe :src="'data:application/pdf;base64,' + label.data" style="width: 100%; height: 500px;"></iframe>
                        </div>
                        <div v-if="label.type === 'QRCODE'">
                            <img :src="'data:image/png;base64,' + label.data" alt="QR Code">
                        </div>
                    </div>
                </div>
                <div v-else><i>Ingen digital fraktsedel att visa</i></div>
            </b-modal>

            <activity-notification v-if="card && card.CardUID" :channel="'prod-order-' + card.CardUID"></activity-notification>
        </div>
        <div v-else class="content">
            <div class="alert alert-danger">Kortnummer/Order hittades inte.</div>
        </div>
    </div>
</template>

<script>
import {
    formatDateTime,
    getWeek,
    formatCurrency,
    nl2br,
} from '@services/Helpers';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import { debounce } from 'lodash';
import { mapState } from 'pinia';
import { count } from 'sms-length';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import TextareaWithValidation from '@components/Form/TextareaWithValidation';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import ElasticTextarea from '@components/ElasticTextarea.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import ActivityNotification from '@components/User/ActivityNotification.vue';
import { useAuthStore } from '@services/pinia/AuthStore';
import ProductFilter from '@components/Filters/ProductFilter.vue';

export default {
    name: 'ProdOrderEdit',
    components: {
        ProductFilter,
        ActivityNotification,
        ElasticTextarea,
        VDatePicker,
        InputWithValidation,
        SelectWithValidation,
        TextareaWithValidation,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        LimitlessButton,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_saving_card: false,
        busy_loading: true,
        busy_saving: false,
        busy_sending_sms: false,
        busy_loading_parcels: false,
        busy_loading_returnorders: false,
        busy_loading_logs: false,
        busy_saving_log: false,
        show_full_log: false,
        card_no: null,
        brand: null,
        card: null,
        prodorder: null,
        duplicates: null,
        comment: {
            CommentText: '',
            CommentType: 'COMMENT',
        },
        statuses: [],
        parcels: null,
        returnorders: [],
        logs: [],
        freight_costs: [],
        codes_item: [],
        is_dirty: false,
        add_product: null,
        deliv_calc_text: null,
        deliv_calc_deliv_date: null,
        deliv_calc_send_date: null,
        deliv_calc_deliv_day: null,
        deliv_calc_send_day: null,
        show_send_button_sms: false,
        show_send_button_email: false,
        mail_type: null,
        mail_preview_url: '',
        mail: {
            message: '',
        },
        sms: {
            from: '',
            to: '',
            message: '',
        },
        comment_types: [
            {
                id: 'COMMENT',
                label: 'Intern kommentar',
            },
            {
                id: 'MAIL',
                label: 'Mailkontakt',
            },
            {
                id: 'TELE',
                label: 'Telefonkontakt',
            },
        ],
        show_shipping_label: null,
        service_point: null,
    }),
    mounted() {
        this.getStatuses();
        this.init();
    },
    watch: {
        id() {
            this.not_found = false;
            this.initialized = false;
            this.card_no = null;
            this.brand = null;
            this.card = null;
            this.prodorder = null;
            this.duplicates = null;
            this.init();
        },
        'prodorder.DeliveryType': function prodorderDeliveryType() {
            this.checkPostalCode(this.prodorder.Zip);
        },
        'prodorder.Zip': function prodorderZip(val) {
            this.checkPostalCode(val);
        },
        'prodorder.WantedDeliveryDate': function prodorderWantedDeliveryDate(newValue) {
            if (this.prodorder.Zip) {
                this.checkPostalCode(this.prodorder.Zip);
            }
            const d = new Date(newValue);
            if (d && d.getDay() === 6) {
                this.prodorder.DeliveryASAP = 1;
            } else {
                this.prodorder.DeliveryASAP = 0;
            }
        },
        mail: {
            deep: true,
            handler: debounce(function mailHandler() {
                const vm = this;
                vm.updateMailPreview();
            }),
        },
    },
    methods: {
        nl2br,
        formatCurrency,
        formatDateTime,
        init() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const cardNo = urlParams.get('card_no');
            this.card_no = cardNo;
            this.getProdOrder(cardNo);
            this.getLogs();
        },
        getStatuses() {
            BackendRepository.getStatuses().then((res) => {
                this.statuses = res;
            });
        },
        getProdOrder(cardNo) {
            this.busy_loading = true;
            apiClient.get('/vue/prodorders/' + this.id + (cardNo ? '?card_no=' + cardNo : ''))
                .then((response) => {
                    if (response.data.prodorder && parseInt(this.id, 10) !== parseInt(response.data.prodorder.ProdOrderID, 10)) {
                        window.location.href = '/prodorders/' + response.data.prodorder.ProdOrderID;
                    }
                    this.duplicates = response.data.duplicates;
                    this.prodorder = response.data.prodorder;
                    this.card = response.data.card;
                    this.brand = response.data.brand;
                    this.service_point = null;
                    if (response.data.prodorder && response.data.prodorder.ProdOrderID > 0) {
                        this.service_point = response.data.prodorder.service_point;
                        this.checkPostalCode(response.data.prodorder.Zip);
                        this.getParcels();
                        this.getReturnOrders();
                        if (response.data.prodorder.Email) {
                            this.show_send_button_email = true;
                        } else {
                            this.show_send_button_email = false;
                        }
                        if (response.data.prodorder.Phone) {
                            this.show_send_button_sms = true;
                        } else {
                            this.show_send_button_sms = false;
                        }
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                });
        },
        async saveProdOrder(redeem = false) {
            let isValid = true;
            if (!redeem) {
                isValid = await this.$refs.prodorderform.validate();
            }
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/prodorders/' + this.id, { redeem, ...this.prodorder, override_delivery_group: this.card.override_delivery_group })
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.prodorder.ProdOrderID, 10)) {
                            window.location.href = '/prodorders/' + response.data.prodorder.ProdOrderID;
                        }
                        this.duplicates = response.data.duplicates;
                        this.prodorder = response.data.prodorder;
                        this.card = response.data.card;
                        this.brand = response.data.brand;
                        this.service_point = response.data.prodorder.service_point;
                        if (!redeem) {
                            this.$refs.btnsaveprodorder.triggerSaved();
                            this.$refs.prodorderform.reset();
                        }
                        if (response.data.prodorder.Email) {
                            this.show_send_button_email = true;
                        } else {
                            this.show_send_button_email = false;
                        }
                        if (response.data.prodorder.Phone) {
                            this.show_send_button_sms = true;
                        } else {
                            this.show_send_button_sms = false;
                        }
                    })
                    .catch((error) => {
                        if (!redeem) {
                            const parsederror = getError(error);
                            if (typeof parsederror === 'object') {
                                this.$refs.prodorderform.setErrors(parsederror);
                            }
                            this.$refs.btnsaveprodorder.triggerFailed();
                        }
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else if (!redeem) {
                this.$refs.btnsaveprodorder.triggerFailed();
            }
        },
        async saveCard() {
            if (this.card) {
                this.busy_saving_card = true;
                await apiClient.post('/vue/card/' + this.card.CardUID, { ...this.card })
                    .then(() => {
                        this.$refs.btnsavecard.triggerSaved();
                    })
                    .catch(() => {
                        this.$refs.btnsavecard.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving_card = false;
                    });
            }
        },
        winOpen(url) {
            const myWindow = window.open(url, 'SHT_InfoPop', 'scrollbars=yes,resizable=yes,width=650,height=800,screenX=100,screenY=100');
            myWindow.focus();
        },
        checkPostalCode: debounce(async function checkPostalCode(code) {
            this.deliv_calc_text = '';
            this.deliv_calc_deliv_date = null;
            this.deliv_calc_send_date = null;
            this.deliv_calc_deliv_day = null;
            this.deliv_calc_send_day = null;
            apiClient.get('/vue/delivery/postalcode?postal_code=' + code + (this.prodorder.CountryCode ? '&country_code=' + this.prodorder.CountryCode : ''))
                .then((response) => {
                    let days = null;
                    if (this.prodorder.DeliveryType === 'postoffice' || this.prodorder.DeliveryType === 'postal') {
                        days = response.data.DaysPostOffice;
                    } else {
                        days = response.data.Days;
                    }
                    if (days > 0) {
                        this.deliv_calc_text = days + ' dagar leverans till <span class="text-uppercase">' + response.data.City + '</span>';
                        if (this.prodorder.WantedDeliveryDate && days) {
                            const delivDate = new Date(this.prodorder.WantedDeliveryDate);
                            const sendDate = new Date(this.prodorder.WantedDeliveryDate);
                            sendDate.setDate(delivDate.getDate() - days);
                            if (sendDate.getDay() === 6) {
                                sendDate.setDate(sendDate.getDate() - 1);
                            } else if (sendDate.getDay() === 0) {
                                sendDate.setDate(sendDate.getDate() - 2);
                            }
                            if (delivDate && sendDate) {
                                this.deliv_calc_deliv_date = delivDate.toISOString().substring(0, 10);
                                this.deliv_calc_send_date = sendDate.toISOString().substring(0, 10);
                                this.deliv_calc_deliv_day = delivDate.toLocaleString('sv', { weekday: 'short' });
                                this.deliv_calc_send_day = sendDate.toLocaleString('sv', { weekday: 'short' });
                            }
                        }
                    } else if (response.data.DelivComment === 'BOX') {
                        this.deliv_calc_text = 'Leverans till Box-postnummer går inte att genomföra, kontrollera adressen!';
                    } else {
                        this.deliv_calc_text = 'Leveranstid saknas för valt leveranssätt, kontrollera leveranssätt och adress!';
                    }
                })
                .catch(() => {
                    if (this.prodorder.CountryCode !== 'SE') {
                        this.deliv_calc_text = 'UTLAND Lev.tid saknas';
                    } else {
                        this.deliv_calc_text = 'Postnumret verkar vara fel, kontrollera adressen!';
                    }
                });
        }, 500),
        addOrderItem(prod, compensation) {
            if (prod) {
                this.prodorder.items.push({
                    ProdOrderItemID: 0,
                    ProdOrderID: this.id,
                    ProdID: prod.ProdID,
                    ProdName: prod.ProdName,
                    product: prod,
                    IsCompensation: compensation,
                });
            }
            this.add_product = null;
        },
        deleteOrderItem(index, rowLocked) {
            let message = 'Är du säker att du vill radera ' + this.prodorder.items[index].ProdName + ' från beställningen?';
            if (rowLocked) {
                message = 'Produktraden är låst! Vill du ändå radera ' + this.prodorder.items[index].ProdName + ' från beställningen?';
            }
            this.$swal({
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera!',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.prodorder.items.splice(index, 1);
                }
            });
        },
        btnPrintLabel() {
            const { dirty } = this.$refs.prodorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skriver ut en fraktsedel!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            window.location.href = '/shipping/print_label?prod_order_id=' + this.prodorder.ProdOrderID;
        },
        btnPrintLetter() {
            const { dirty } = this.$refs.prodorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skriver ut en brevetikett!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            // window.location.href = '/batch/list?type=prod_order&print_letter=true&ids[]=' + this.prodorder.ProdOrderID;
            window.location.href = '/shipping/print_letter?prod_order_id=' + this.prodorder.ProdOrderID;
        },
        btnPrintPtoch() {
            const { dirty } = this.$refs.prodorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skriver ut en fraktsedel!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }
            window.open(this.old_system_url + '/showPDF_PtouchDeliverylabel.php?func=printbatch&ProdOrderID=' + this.prodorder.ProdOrderID, 'PtouchLabelWin', 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=1,width=500,height=400');
        },
        getParcels() {
            this.busy_loading_parcels = true;
            apiClient.get('/vue/shipping/parcels?type=prodorder&reference=' + this.prodorder.ProdOrderID)
                .then((response) => {
                    this.parcels = response.data;
                    if (response.data && (response.data.unifaun.length > 0 || response.data.ntaps.length > 0)) {
                        this.$nextTick(() => {
                            document.getElementById('collapse-parcels').classList.add('show');
                        });

                        const freightCosts = [];
                        response.data.unifaun.forEach((parcel) => {
                            if (Array.isArray(parcel.price_spec)) {
                                parcel.price_spec.forEach((cost) => {
                                    freightCosts.push({
                                        parcel_number: parcel.kollino,
                                        price: parseFloat(cost.totpris),
                                        price_approved: cost.isApproved,
                                        price_date: cost.skapadDatum,
                                        price_invoice_no: cost.fakturaspecnr,
                                    });
                                });
                            }
                        });
                        response.data.ntaps.forEach((parcel) => {
                            if (parcel.price_invoice_no) {
                                freightCosts.push({
                                    parcel_number: parcel.parcel_number,
                                    price: parseFloat(parcel.price),
                                    price_approved: parcel.price_approved,
                                    price_date: parcel.price_date,
                                    price_invoice_no: parcel.price_invoice_no,
                                });
                            }
                        });
                        if (freightCosts.length > 0) {
                            document.getElementById('collapse-freight-costs').classList.add('show');
                            this.freight_costs = freightCosts;
                        }
                    }
                })
                .finally(() => {
                    this.busy_loading_parcels = false;
                });
        },
        getLogs() {
            this.busy_loading_logs = true;
            apiClient.get('/vue/prodorders/' + this.id + '/logs?card_no=' + (this.card ? this.card.CardUID : this.card_no))
                .then((response) => {
                    this.logs = response.data;
                })
                .finally(() => {
                    this.busy_loading_logs = false;
                });
        },
        async saveComment() {
            const isValid = await this.$refs.logform.validate();
            if (isValid) {
                this.busy_saving_log = true;
                await apiClient.post('/vue/prodorders/' + this.id + '/logs/0', { ...this.comment })
                    .then(() => {
                        this.comment.CommentText = '';
                        this.comment.CommentType = 'COMMENT';
                        this.$refs.btnsavecomment.triggerSaved();
                        this.$refs.logform.reset();
                    }).catch(() => {
                        this.$refs.btnsavecomment.triggerFailed();
                    }).finally(() => {
                        this.busy_saving_log = false;
                        this.getLogs();
                    });
            } else {
                this.$refs.btnsavecomment.triggerFailed();
            }
        },
        getReturnOrders() {
            this.busy_loading_returnorders = true;
            apiClient.get('/vue/returnorders?card_no=' + this.card.CardUID)
                .then((response) => {
                    if (response.data.data.length > 0) {
                        this.returnorders = response.data.data;
                        document.getElementById('collapse-product-complaints').classList.add('show');
                    }
                })
                .finally(() => {
                    this.busy_loading_returnorders = false;
                });
        },
        async showCodes(item) {
            await apiClient.get('/vue/prodorders/items/' + item.ProdOrderItemID + '/codes')
                .then((response) => {
                    item.codes = [...response.data];
                    this.codes_item = item;
                });
            this.$bvModal.show('modal-show-codes');
        },
        async showModalSms(type = 'message') {
            const { dirty } = this.$refs.prodorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skickar sms!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            // eslint-disable-next-line quotes
            this.sms.message = "Ang. Kort: " + this.card.CardUID + "\n\n\nKontakta oss via epost " + (this.brand?.email ? this.brand.email : "kundservice@supekort.se");
            this.sms.to = this.prodorder.Phone;
            this.sms.from = 'Supékort';
            if (this.brand) {
                this.sms.from = this.brand.name;
            }
            if (type !== 'message') {
                apiClient.get('/prodorders/' + this.id + '/smspreview/' + type)
                    .then((response) => {
                        this.sms.message = response.data;
                        this.$root.$bvModal.show('modal_sms_form');
                    });
            } else {
                this.$root.$bvModal.show('modal_sms_form');
            }
        },
        async sendSms(event) {
            event.preventDefault();
            const isValid = await this.$refs.smsform.validate();
            if (isValid) {
                this.busy_sending_sms = true;
                await apiClient.post('/vue/prodorders/' + this.id + '/send/sms', { ...this.sms })
                    .then(() => {
                        this.$refs.btnsendsms.triggerSaved();
                        this.$refs.smsform.reset();
                        this.$root.$bvModal.hide('modal_sms_form');
                        this.$swal({
                            icon: 'success',
                            title: 'Sms:et har skickats!',
                            confirmButtonText: 'OK',
                            showCancelButton: false,
                            timer: 2222,
                        });
                    }).catch(() => {
                        this.$refs.btnsendsms.triggerFailed();
                    }).finally(() => {
                        this.busy_sending_sms = false;
                        this.getLogs();
                    });
            } else {
                this.$refs.btnsendsms.triggerFailed();
            }
        },
        showModalMail(mailType) {
            const { dirty } = this.$refs.prodorderform.flags;
            if (dirty) {
                this.$swal({
                    text: 'Du måste spara ändringarna innan du skickar mail!',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            this.mail_type = mailType;
            this.updateMailPreview();
            this.$root.$bvModal.show('modal_mail_preview');
            this.mail.message = '';
        },
        async sendMail(event) {
            event.preventDefault();
            await apiClient.post('/vue/prodorders/' + this.prodorder.ProdOrderID + '/send/' + this.mail_type, { ...this.mail })
                .then(() => {
                    const message = this.mail_type_human.charAt(0).toUpperCase() + this.mail_type_human.slice(1) + ' skickad!';
                    this.$root.$bvModal.hide('modal_mail_preview');
                    this.$swal({
                        icon: 'success',
                        title: message,
                        confirmButtonText: 'OK',
                        showCancelButton: false,
                        timer: 2222,
                    });
                }).catch((error) => {
                    this.$refs.btnsendmail.triggerFailed();
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.mailform.setErrors(parsederror);
                    } else {
                        let message = 'Något gick fel...';
                        if (error.response && error.response.data && error.response.data.message) {
                            message = error.response.data.message;
                        }
                        this.$swal({
                            icon: 'error',
                            title: 'Error!',
                            text: message,
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Avbryt',
                        });
                    }
                });
        },
        updateMailPreview() {
            this.mail_preview_url = '/prodorders/' + this.id + '/mailpreview/' + this.mail_type + '?' + Object.keys(this.mail).filter((k) => this.mail[k]).map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(this.mail[k])}`).join('&');
        },
        blockCard() {
            if (this.card && this.card.card_order) {
                this.$swal({
                    text: 'Är du säker på att du vill spärra detta kort (' + this.card.CardUID + ')?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, spärra!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        apiClient.post('/vue/cardorder/' + this.card.card_order.OrderID + '/block/card', { card_number: this.card.CardUID })
                            .then(() => {
                                this.card.isBlocked = 1;
                            });
                    }
                });
            }
        },
        unblockCard() {
            if (this.card && this.card.card_order) {
                this.$swal({
                    text: 'Är du säker på att du vill ta bort spärren på detta kort (' + this.card.CardUID + ')?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, spärra!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        apiClient.post('/vue/cardorder/' + this.card.card_order.OrderID + '/unblock/card', { card_number: this.card.CardUID })
                            .then(() => {
                                this.card.isBlocked = 0;
                            });
                    }
                });
            }
        },
        async toggleCustomerWaiting() {
            const isValid = await this.$refs.prodorderform.validate();
            if (!isValid) {
                this.$swal({
                    text: 'Du måste åtgärda valideringsfelen innan du kan ändra status.',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            await this.$swal({
                text: 'Är du säker att du vill ändra?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, ändra!',
            }).then((result) => {
                if (result.isConfirmed) {
                    if (this.prodorder.customerWaiting) {
                        this.prodorder.customerWaiting = null;
                    } else {
                        const date = new Date();
                        this.prodorder.customerWaiting = date.toISOString().substring(0, 19).replace('T', ' ');
                    }
                    this.saveProdOrder(false);
                }
            });
        },
        async changeStatus(statusId) {
            const isValid = await this.$refs.prodorderform.validate();
            if (!isValid) {
                this.$swal({
                    text: 'Du måste åtgärda valideringsfelen innan du kan ändra status.',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK!',
                    times: 3000,
                });
                return;
            }

            const status = this.statuses.find((s) => s.id === statusId);
            if (status) {
                await this.$swal({
                    text: 'Är du säker att du vill ändra status till "' + status.name + '"?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, ändra!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.prodorder.StatusID = status.id;
                        this.saveProdOrder(false);
                    }
                });
            }
        },
        tearShippingLabel(parcelNumber) {
            const inputOptions = {
                no_change: 'Ingen statusändring',
            };
            this.allowed_status_change.filter((s) => s.id <= 250).forEach((s) => {
                inputOptions[s.id] = `Ändra till status ${s.id}, ${s.name}`;
            });
            this.$swal({
                text: 'Är du säker på att du vill riva denna fraktsedel (' + parcelNumber + ')?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, riv den!',
                input: 'radio',
                inputOptions,
                inputValue: 'no_change',
            }).then((result) => {
                if (result.isConfirmed) {
                    apiClient.post('/vue/shipping/parcels/tear', { parcels: [parcelNumber] })
                        .then(() => {
                            this.getParcels();
                        });
                    if (result.value >= 0 && result.value <= 999 && result.value !== 'no_change') {
                        this.prodorder.StatusID = result.value;
                        this.saveProdOrder(false);
                    }
                }
            });
        },
        showShippingLabel(parcel) {
            this.show_shipping_label = parcel;
            this.$bvModal.show('modal_show_shipping_label');
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        send_by_mail() {
            if (this.prodorder) {
                const countByMail = this.prodorder.items.filter((item) => item.product.sendByMail).length;
                if (countByMail > 0 && countByMail === this.prodorder.items.length) {
                    return true;
                }
            }
            return false;
        },
        service_point_criteria() {
            if (this.prodorder) {
                return {
                    country_code: this.prodorder.CountryCode,
                    postal_code: this.prodorder.Zip,
                };
            }
            return {};
        },
        prodorder_name() {
            return (this.prodorder && this.prodorder.ProdOrderID > 0 ? 'Kortnummer ' + this.prodorder.CardNo : 'Ny order');
        },
        prodorder_id() {
            return (this.prodorder && this.prodorder.ProdOrderID > 0 ? this.prodorder.ProdOrderID : '');
        },
        filteredLogs() {
            // return this.logs.filter((log) => this.show_full_log || log.Type === 2);
            return [...this.logs].reverse();
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        deliv_date_str() {
            if (this.prodorder && this.prodorder.WantedDeliveryDate && this.prodorder.WantedDeliveryDate !== '0000-00-00') {
                const d = new Date(this.prodorder.WantedDeliveryDate);
                if (d) {
                    return d.toLocaleString('sv', { weekday: 'short' });
                }
            }
            return '';
        },
        date_send_str() {
            if (this.prodorder && this.prodorder.CalcShippingDate && this.prodorder.CalcShippingDate !== '0000-00-00' && !this.prodorder.DeliveryASAP) {
                const d = new Date(this.prodorder.CalcShippingDate);
                if (d) {
                    if (d.getDay() === 0 || d.getDay() === 6) {
                        return 'Vecka ' + getWeek(this.prodorder.CalcShippingDate);
                    }
                    return d.toLocaleString('sv', { weekday: 'short' });
                }
            }
            return '';
        },
        search_name_link() {
            if (this.prodorder) {
                const searchString = [this.prodorder.Name, this.prodorder.City].filter((str) => str).join(' ');
                return {
                    hitta: 'http://www.hitta.se/sök?vad=' + encodeURIComponent(searchString),
                    ratsit: 'https://www.ratsit.se/sok/person?vem=' + encodeURIComponent(searchString),
                };
            }
            return {
                hitta: null,
                ratsit: null,
            };
        },
        search_company_link() {
            if (this.prodorder) {
                const searchString = [this.prodorder.Company, this.prodorder.City].filter((str) => str).join(' ');
                return {
                    hitta: 'http://www.hitta.se/sök?vad=' + encodeURIComponent(searchString),
                    ratsit: 'https://www.ratsit.se/sok/person?vem=' + encodeURIComponent(searchString),
                };
            }
            return {
                hitta: null,
                ratsit: null,
            };
        },
        search_adress_link() {
            if (this.prodorder && this.prodorder.Street) {
                let street = this.prodorder.Street;
                const isnum = /^\d+$/.test(this.prodorder.Street.substr(this.prodorder.Street.length - 4));
                const hasnum = /\d/.test(this.prodorder.Street.substr(0, this.prodorder.Street.length - 4));
                if (isnum && hasnum) {
                    street = this.prodorder.Street.substr(0, this.prodorder.Street.length - 5);
                }
                const searchString = [this.prodorder.Name, street, this.prodorder.City].filter((str) => str).join(' ');
                return {
                    hitta: 'http://www.hitta.se/sök?vad=' + encodeURIComponent(searchString),
                    ratsit: 'https://www.ratsit.se/sok/person?vem=' + encodeURIComponent(searchString),
                };
            }
            return {
                hitta: null,
                ratsit: null,
            };
        },
        search_phone_link() {
            if (this.prodorder) {
                const searchString = [this.prodorder.Phone].filter((str) => str).join(' ');
                return {
                    hitta: 'http://www.hitta.se/sök?vad=' + encodeURIComponent(searchString),
                    ratsit: 'https://www.ratsit.se/sok/person?vem=' + encodeURIComponent(searchString),
                };
            }
            return {
                hitta: null,
                ratsit: null,
            };
        },
        street_wo_apartmentno() {
            let street = null;
            if (this.prodorder && this.prodorder.Street) {
                street = this.prodorder.Street;
                const isnum = /^\d+$/.test(this.prodorder.Street.substr(this.prodorder.Street.length - 4));
                const hasnum = /\d/.test(this.prodorder.Street.substr(0, this.prodorder.Street.length - 4));
                if (isnum && hasnum) {
                    street = this.prodorder.Street.substr(0, this.prodorder.Street.length - 5);
                }
            }

            return street;
        },
        mail_type_human() {
            if (this.mail_type === 'confirmation') {
                return 'Bekräftelse';
            }
            if (this.mail_type === 'delivery_notice') {
                return 'Leveransbesked';
            }
            if (this.mail_type === 'ready_for_pickup') {
                return 'Finns att hämta-mail';
            }
            return 'message';
        },
        is_paused() {
            let paused = false;
            if (this.prodorder && this.prodorder.PausedUntilTS) {
                const pauseDate = new Date(this.prodorder.PausedUntilTS.replace(' ', 'T'));
                const nowDate = new Date();
                if (pauseDate.getTime() > nowDate.getTime()) {
                    paused = true;
                }
            }
            return paused;
        },
        sms_count() {
            return count(this.sms.message);
        },
        allowed_status_change() {
            const arr = [];
            if (this.prodorder && this.prodorder.ProdOrderID > 0) {
                if (this.prodorder.StatusID < 400) {
                    arr.push(0);
                    arr.push(55);
                    arr.push(250);
                    if (this.prodorder.StatusID === 55) {
                        arr.push(60);
                        arr.push(600);
                    }
                    arr.push(610);
                }
                if (this.prodorder.StatusID !== 505) {
                    arr.push(500);
                }
                if (this.prodorder.StatusID !== 500) {
                    arr.push(505);
                }
                arr.push(590);
            }

            return this.statuses.filter((status) => status.id !== this.prodorder.StatusID && arr.includes(status.id));
        },
        customer_waiting_class() {
            if (this.prodorder) {
                if (this.prodorder.customerWaiting) {
                    return 'btn-warning';
                }
                // return 'btn-outline-' + this.prodorder.status.Class;
            }
            return 'btn-light';
        },
        has_packages_en_route() {
            return this.parcels && this.parcels.ntaps && this.parcels.ntaps.some((s) => {
                const serviceType = (s.shipment && s.shipment.service_type) ? s.shipment.service_type : '';
                return s.statuscode > 1 && s.statuscode < 6 && !serviceType.includes('RETURN');
            });
        },
        has_packages_to_collect() {
            return this.parcels && this.parcels.ntaps && this.parcels.ntaps.some((s) => {
                const serviceType = (s.shipment && s.shipment.service_type) ? s.shipment.service_type : '';
                return s.statuscode === 6 && !serviceType.includes('RETURN');
            });
        },
    },
};
</script>
